import { createSlice } from '@reduxjs/toolkit';
import { getAllPermissions } from './allPermissionsThunks';

const initialState = {
  permissions: [],
};

export const AllPermissionsSlice = createSlice({
  name: 'allPermissions',
  initialState,
  reducers: {
    setAllPermissions: (state, action) => {
      state.permissions = action.permissions;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPermissions.pending, (state) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(getAllPermissions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.permissions = action.payload;
        state.status = action.payload;
        state.error = false;
      })
      .addCase(getAllPermissions.rejected, (state) => {
        state.isLoading = false;
        state.error = 500;
      });
  },
});

export const { setAllPermissions } = AllPermissionsSlice.actions;
export const permissions = (state) => state.permissions;
export default AllPermissionsSlice.reducer;
